<template>
  <div class="custom-navigation custom-btn-navigation" @click="btnLink">
    <CircleNav :isOn="isOn"></CircleNav>
    <p>{{ btnText }}</p>
  </div>
</template>

<script>
import CircleNav from './CircleNav.vue'

  export default {
    props: {
      btnText: {
        type: String,
        required: true
      },
      routerLink: {
        type: String,
        required: true
      },
    },
    components: {
      CircleNav,
    },
    data() {
      return {
        msg: 'Hi there!',
        isOn: false
      }
    },
    created() {
      this.isOn = this.$route.name === this.routerLink;
    },
    watch: {
      '$route' () {
        this.isOn = this.$route.name === this.routerLink;
      }
    },
    methods: {
      btnLink: function() {
        if(this.$route.name !== this.routerLink) {
          this.$router.push({ name: this.routerLink });
        }
      }
    }
  }
</script>

<style scoped>
  .custom-btn-navigation {
    padding-left: 6px;
    padding-right: 6px;
  }
  
  .custom-btn-navigation:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    cursor: pointer;
  }
</style>